import { __rest } from "tslib";
export function parseGetLinguisticControlsResponse(_a) {
    var { size } = _a, data = __rest(_a, ["size"]);
    return (Object.assign(Object.assign({}, data), { perPage: size }));
}
